module.exports = __webpack_public_path__ + "img/user.e8d7d05f.jpg";